import { FilterType, IRankingOrganisationSearchFilters } from '@studyportals/ranking-api-interface';
import { IOrganisationSearchFilters } from '@studyportals/search-api-interface';

export class SearchRankingFiltersMapper {

	private static readonly baseRankingId = 5;
	private static readonly showUnranked: 'true' | 'false' = 'true';
    
	public static map(filters: IOrganisationSearchFilters): IRankingOrganisationSearchFilters {
		return {
			[FilterType.ORGANISATION]: filters.organisationId,
			[FilterType.COUNTRIES]: filters.countryIsoCodes ? filters.countryIsoCodes.join(',') : undefined,
			[FilterType.REGIONS]: filters.regionIds ? filters.regionIds.join(',') : undefined,
			[FilterType.AREAS]: filters.areaIds ? filters.areaIds.join(',') : undefined,
			[FilterType.DISCIPLINE]: filters.disciplines ? filters.disciplines.join(',') : 'null',
			[FilterType.DELIVERY_METHODS]: filters.deliveryMethods ? filters.deliveryMethods.join(',') : undefined,
			[FilterType.BASE_RANKING_ID]: this.baseRankingId.toString(),
			[FilterType.YEAR]: "latest",
			[FilterType.SHOW_UNRANKED]: this.showUnranked
		}
	}
}
